import PropTypes from 'prop-types'
import {styled} from '@mui/material/styles'
import Box from '@mui/material/Box'
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline'
import Typography from '@mui/material/Typography'

const PREFIX = 'ChartDataRefetchOnError'

const classes = {
  icon: `${PREFIX}-icon`,
  loadDataBoxAction: `${PREFIX}-loadDataBoxAction`
}

const StyledBox = styled(Box)(({theme}) => ({
  padding: theme.spacing(10),
  [`& .${classes.icon}`]: {
    color: theme.palette?.graph?.icon
  },

  [`& .${classes.loadDataBoxAction}`]: {
    fontWeight: theme.typography.fontWeightBold,
    color: theme.palette.hpBaseDark
  }
}))

function ChartDataRefetchOnError({onTryAgain}) {
  const filtersOpen = {}

  return (
    <StyledBox display='flex' flexDirection='column' alignItems='center'>
      <ErrorOutlineIcon
        style={{width: '0.4em', height: '0.4em', fontSize: filtersOpen ? 'calc(80px + 2vh)' : 'calc(80px + 8vh)'}}
        classes={{colorPrimary: classes.icon.color}}
        color='primary'
      />
      <Typography variant='h6' className={classes.loadDataBoxAction} style={{fontSize: filtersOpen ? '75%' : ''}}>
        Selections are not appropriate, please adjust filter selections or{' '}
        <button
          onClick={onTryAgain}
          style={{background: 'none', border: 'none', color: 'inherit', cursor: 'pointer', textDecoration: 'underline'}}
        >
          try again
        </button>
      </Typography>
    </StyledBox>
  )
}

ChartDataRefetchOnError.propTypes = {
  onTryAgain: PropTypes.func
}

export default ChartDataRefetchOnError

/**
 * ChartDataRefetchOnError - A React component that displays an error message with an option to retry data fetching.
 */
